module.exports = __webpack_public_path__ + "static/media/default_user_logo.cdb24080.svg";